//
// Module for the Print To PDF Configuration edit
//
rs.module("system_/configuration/printtopdf/edit",

    ["ui/controls/input-tokens"],

    function (inputTokens) {

        // Initialize the module
        function initialize(jsSelectors, ajaxUrls) {
            var printToPdfConfigForm = $.js(jsSelectors.printToPdfConfigForm);

            var processTypeSelect = printToPdfConfigForm.js(jsSelectors.processTypeSelect);
            var tokens = printToPdfConfigForm.js(jsSelectors.tokens);

            // On select change, reload the tokens via ajax
            processTypeSelect.change(function () {
                $.get(ajaxUrls.getTokens, { processType: this.value }).done(function (result) {
                    tokens.html(result);
                    inputTokens.reinitialize();
                });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);